import lodash from 'lodash';

import { TComposerClip } from '../components/Composer/ComposerRow';
import { TClip } from '../components/Timeline/TimelineClip';

type TSelectedClip = TClip & {
  rowIndex?: number;
  topicId?: string;
  topicName?: string;
};

type TTopicsMap = Record<
  string,
  {
    topicName: string;
    clipCount: number;
    clipIds: string[];
  }
>;

export const getTopicsToDisplay = ({
  sortedSelectedClips = [],
  currentSelectedComposerClips = [],
  secondarySelectedClips = [],
  composerRows = [],
}: {
  sortedSelectedClips?: TSelectedClip[];
  currentSelectedComposerClips?: TSelectedClip[];
  secondarySelectedClips?: TSelectedClip[];
  composerRows?: TComposerClip[];
}): TTopicsMap => {
  const obj: TTopicsMap = {};

  if (secondarySelectedClips.length) {
    secondarySelectedClips.forEach((clip) => {
      if (clip?.topicId && obj[clip?.topicId]) {
        obj[clip?.topicId].clipCount += 1;
      } else if (clip?.topicId && clip.topicName && !obj[clip?.topicId]) {
        obj[clip?.topicId] = {
          topicName: clip.topicName,
          clipCount: 1,
          clipIds: [clip.id],
        };
      }
    });
  } else if (currentSelectedComposerClips.length) {
    const selectComposerClips = lodash.cloneDeep(currentSelectedComposerClips);
    selectComposerClips.forEach((clip, i) => {
      if (!clip?.topicId && typeof clip?.rowIndex === 'number' && composerRows[clip.rowIndex]) {
        selectComposerClips[i].topicId = composerRows[clip.rowIndex].id;
      }
    });

    selectComposerClips.forEach((clip) => {
      if (clip?.topicId && obj[clip?.topicId]) {
        obj[clip?.topicId].clipCount += 1;
        obj[clip?.topicId].clipIds.push(clip.id);
      } else if (clip?.topicId && clip.topicName && !obj[clip?.topicId] && typeof clip?.rowIndex === 'number') {
        obj[clip?.topicId] = {
          topicName: composerRows[clip.rowIndex].name,
          clipCount: 1,
          clipIds: [clip.id],
        };
      } else if (typeof clip?.rowIndex === 'number' && composerRows[clip.rowIndex]) {
        obj[composerRows[clip.rowIndex].id] = {
          topicName: composerRows[clip.rowIndex].name,
          clipCount: 1,
          clipIds: [clip.id],
        };
      }
    });
  } else if (sortedSelectedClips.length) {
    sortedSelectedClips.forEach((clip) => {
      if (clip?.topicId && obj[clip?.topicId]) {
        obj[clip?.topicId].clipCount += 1;
        obj[clip?.topicId].clipIds.push(clip.id);
      } else if (clip?.topicId && clip.topicName && !obj[clip?.topicId]) {
        obj[clip?.topicId] = {
          topicName: clip.topicName,
          clipCount: 1,
          clipIds: [clip.id],
        };
      }
    });
  }

  return obj;
};
